import React, { useCallback, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Button, IconSocialAppleDefault } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { initAppleSignIn, appleSignIn } from '../../services'
import classes from './AppleButton.module.scss'

const AppleButton = ({
  onLogin,
  onClick,
}: {
  onLogin: (data: unknown) => void
  onClick?: () => void
}) => {
  useEffect(() => {
    initAppleSignIn()
  }, [])

  const { t } = useTranslation('@mc/authentication')

  const handleClick = useCallback(async () => {
    onClick?.()
    const data = await appleSignIn()
    if (onLogin && data) {
      onLogin(data)
    }
  }, [onLogin, onClick])

  return (
    <Button kind='apple' fullWidth onClick={handleClick}>
      <IconSocialAppleDefault size='lg' className={`${classes.icon} mc-mr-3`} />
      {t('apple')}
    </Button>
  )
}

AppleButton.propTypes = {
  onLogin: PropTypes.func,
  t: PropTypes.func,
}

export default AppleButton
